import "./photoshop.css";

import {google} from "../../commonjs/google.js";
import {get_scrollY} from "../../commonjs/scroll.js";
import {get_device} from "../../commonjs/device.js";
import {IE_scroll} from "../../commonjs/IE_scroll.js";

window.onload = ()=>{
                google();
                const morerole = document.getElementById(`morerole`);
                const basic_button = document.getElementById(`basic_button`);
                const Extension = document.getElementById(`Extension`);
                const Photoshop_script = document.getElementById(`Photoshop_script`);
                const electron_soft = document.getElementById(`electron_soft`);
                
                const title = document.getElementById(`title`);
                const Basic_list = document.getElementById(`Basic_list`);
                const extension_list = document.getElementById(`extension_list`);
                const Ps_script = document.getElementById(`Ps_script`);
                const electron_list = document.getElementById(`electron_list`);
                
                const list_title = document.getElementsByClassName(`list_title`);
                const button = document.getElementsByClassName(`button`);
                const asides = document.getElementsByTagName(`aside`);
                const overlay = document.getElementById(`overlay`);
                
              IE_scroll();//IE対策
              
              
                window.addEventListener(`scroll`,()=>{
                    let scroll_Y = get_scrollY();
                    console.log(scroll_Y);
                    const trans = parseFloat(document.defaultView.getComputedStyle(morerole,null).opacity);
                    const title_trans = parseFloat(document.defaultView.getComputedStyle(title,null).opacity); 
                    
                    if(scroll_Y>700){
                        title.animate([{opacity:title_trans},{opacity:0}],{
                           duration:1000,
                            fill:`forwards`
                        });
                    }
                    
                    if(scroll_Y<650){
                        title.animate([{opacity:title_trans},{opacity:1}],{
                            duration:1000,
                            fill:`forwards`
                        });
                    }
                    
                    
                   
                    if(scroll_Y>3000){
                        morerole.animate([{opacity:trans},{opacity:1}],{
                            duration:1000,
                            fill:`forwards`  
                        });
                    }
                    
                    if(scroll_Y<2500){
                        morerole.animate([{opacity:trans},{opacity:0}],{
                            duration:1000,
                            fill:`forwards`  
                        });
                    }
                },false);
                
                
            /*================================list event==========================*/    
                
                const Viwer_list = function(button,elm,num){
                    this.button = button;
                    this.elm = elm;
                    this.close = document.getElementsByClassName(`close`)[num];
                    this.button.addEventListener(`click`,this,false);
                }
                
                Viwer_list.prototype.handleEvent = function(){
                    const elm = this.elm;
                    
                    getting_list(fadein);
                    function getting_list(callback){
                            overlay.style.display = `block`;
                            elm.style.display =`block`;
                            callback(elm);
                    }
                    function fadein(){
                            overlay.animate([{opacity:0},{opacity:1}],{
                                duration:1000,
                                fill:`forwards`
                            });
                        
                            elm.animate([{opacity:0},{opacity:1}],{
                                duration:1000,
                                fill:`forwards`
                            });
                    }
                    this.close.addEventListener(`click`,function(){
                        const fadeout = elm.animate([{opacity:1},{opacity:0}],{
                            duration:1000,
                            fill:`forwards`
                        });
                        
                        overlay.animate([{opacity:1},{opacity:0}],{
                            duration:1000,
                            fill:`forwards` 
                        });
                        
                        fadeout.addEventListener(`finish`,function(){
                            elm.style.display = `none`;
                            overlay.style.display = `none`;
                        },false);
                    });//callbackでフェードイン、アウト前後のディスプレイ　プロパティも操作
                }
              const _basic = new Viwer_list(basic_button,Basic_list,0);    
              const _extensions = new Viwer_list(Extension,extension_list,1);  
              const _photoshop = new Viwer_list(Ps_script,Photoshop_script,2);
              const _electron = new Viwer_list(electron_list,electron_soft,3);    
               
                
            /*=============================scroll event====================================================*/    
                const Scroll_title = function(elm,color){
                        this.elm = elm;
                        const rect = this.elm.getBoundingClientRect();
                        this.scroll = rect.top+window.pageYOffset;
                        this.color = color;
                        
                        window.addEventListener(`scroll`,this,false);
                    }
                
               Scroll_title.prototype.handleEvent = function(){
                   this.window_scroll_Y = get_scrollY();
                   const trans_color = document.defaultView.getComputedStyle(this.elm,null).backgroundColor;
                        
                        if(this.window_scroll_Y>this.scroll-500&&!this.elm.dataset.flag){
                            this.elm.dataset.flag = true;
                            
                            this.elm.animate([{backgroundColor:trans_color},{backgroundColor:this.color}],{
                                duration:1800,
                                fill:`forwards` 
                            });
                        }
               }
                    
            const title01 = new Scroll_title(list_title[0],`rgba(220,255,200,0.3)`);
            const _extension = new Scroll_title(list_title[1],`rgba(220,220,200,0.3)`);
            const _psscript = new Scroll_title(list_title[2],`rgba(240,220,200,0.3)`);    
            const _electrontitle = new Scroll_title(list_title[3],`rgba(200,220,180,0.3)`);  
                
                
                
            /*===========================touch event===========================================================*/
              const List_button = function(num,color){
                  this.elm = button[num];
                  this.color = color;
                  
                  const rect = this.elm.getBoundingClientRect();
                  this.scroll = rect.top+window.pageYOffset;
                  
                  window.addEventListener(`touchmove`,this,false);
              }
              
              List_button.prototype.handleEvent = function(){
                  this.window_scroll_Y = get_scrollY();
                  const transparency = document.defaultView.getComputedStyle(this.elm,null).backgroundColor;
                  
                  /*if(window.scrollY>this.scroll-100&&this.elm.dataset.flag){
                      this.elm.dataset.flag = false;
                      
                      this.elm.animate([{backgroundColor:transparency},{backgroundColor:`rgba(0,0,0,0)`}],{
                          duration:1000,
                          fill:`forwards`
                      });
                  }*/
                  
                  if(this.window_scroll_Y>this.scroll-500&&!this.elm.dataset.flag){
                      this.elm.dataset.flag = true;
                      
                      this.elm.animate([{backgroundColor:transparency},{backgroundColor:this.color}],{
                          duration:1000,
                          fill:`forwards`
                      });
                  }
                  
                  
                  
              }
              
              
                const basiclist_button = new List_button(0,`rgba(220,255,200,0.3)`);
                const extension_button = new List_button(1,`rgba(250,255,200,0.3)`);
                const photoshop_button = new List_button(2,`rgba(230,255,190,0.3)`);
                const electron_button = new List_button(3,`rgba(200,255,240,0.3)`);
                
                
                const Move_smart_menu = function(num){
                    this.elm = asides[num];
                    
                    
                    this.elm.addEventListener(`touchstart`,this,false);
                }
                
                
                Move_smart_menu.prototype.handleEvent = function(e){
                    
                    const rect = this.elm.getBoundingClientRect();
                    const positionY = !this.elm.style.top ? `0px` : parseFloat(this.elm.style.top);
                    this.elm.setAttribute(`top`,positionY);
                    
                    this.elm.setAttribute(`touch_start`,e.touches[0].clientY);
                    this.elm.addEventListener(`touchmove`,touch_moveY,false);
                    
                    const element = this.elm;
                    
                    function touch_moveY(e){
                        e.preventDefault(); 
                        const how_long_move = parseFloat(element.getAttribute(`top`)) + (e.touches[0].clientY - parseFloat(element.getAttribute(`touch_start`)));
                        if(how_long_move>0){
                            return false;
                        }
                        
                        element.style.top = how_long_move + `px`;
                        element.addEventListener(`touchend`,(e)=>{
                            element.removeEventListener(`touchmove`,touch_moveY,false);
                        },false);
                        
                    }
                }
                
                const _zero = new Move_smart_menu(0);
                const _one = new Move_smart_menu(1);
                const _two = new Move_smart_menu(2);
                const four = new Move_smart_menu(3);
                
            }